import { useQueryClient } from '@tanstack/react-query';
import { get } from 'api/base';
import { useCallback } from 'react';

export const usePatientName = () => {
  const queryClient = useQueryClient();

  const fetchPatientName = useCallback(
    async (input: string) => {
      return queryClient.fetchQuery({
        queryKey: ['patientName', input],
        queryFn: () => get('getPatientName', input) as Promise<string | null>,
        retry: false,
        staleTime: 0,
      });
    },
    [queryClient]
  );

  return { fetchPatientName };
};
